import { toast } from "react-toastify";
import { computed, observable } from "mobx";
import * as moment from "moment";
import { api_adm } from "../../api";
import { api } from "../../api";
import { ICalc, ICalcVar, IConta, newIRecolhimento } from "../../model";
import { sortBy } from "../../utils";
import { LookupStore } from "../LookupStore";
import { NodeData } from "react-folder-tree";

class _CalcStore {

  obs = observable({
    calcs: [] as ICalc[],
    itens_classificacao: [] as any,
    calcs_index: [] as ICalc[],
    contas: [] as any,
    filter: "" as string,
    tipo: "entrada" as string,
    sub_tipo: "simples_nacional" as string,
    filterText: "" as string,
    tab_codigos: "origem" as string,
    calcs_class: [] as ICalc[],
  })

  async load() {

    let resp = await api.get("/api/calcs")

    this.obs.calcs = [];

    const updatedCalcs = resp.data?.map((calc: ICalc) => ({
      ...calc,
      icms_classificacao: LookupStore.getIcmsClassificacao(calc.icms_classificacao_id),
    }));

    this.obs.calcs = [...this.obs.calcs, ...updatedCalcs];

  }

  async get(id: string, tipo: string): Promise<ICalc> {
    try {
      let params = {
        id: id,
        tipo: tipo
      }

      let resp = await api_adm.post(`/api/admin/calcs/show`, params);

      if (!resp.data.recolhimento) {
        resp.data.recolhimento = newIRecolhimento()
        return resp.data
      } else {
        return resp.data;
      }
    } catch (ex) {
      toast.error("Erro ao carregar Caculos!", {});
    }
  }

  lookup(id: number): ICalc {
    return this.obs.calcs.find(c => c.id == id);
  }

  async handleSave(calc: ICalc) {

    if (calc.id) {

      return await this.handleUpdate(calc)

    }

    return await this.handleCreate(calc)

  }

  async handleUpdate(calc: ICalc) {

    try {

      let resp = await api_adm.put(`/api/admin/calcs/${calc.id}`, calc);

      if (resp.data.ok) {

        toast.success('Cálculo salvo com sucesso', {});

        return true

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (e) {

      toast.error("Erro ao salvar Cálculo!", {});

    }

    return false

  }

  async handleCreate(calc: ICalc) {

    try {

      let resp = await api_adm.post("/api/admin/calcs", calc);


      if (resp.data.ok) {

        toast.success('Cálculo criado com sucesso', {});

        return true

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (e) {

      toast.error("Erro ao criar Cálculo!", {});

    }

    return false

  }

  alterarPrioridade = (itens, order, direcao) => {

    let novaLista = [...itens];

    const itemIndex = novaLista.findIndex((item) => item.order === order);

    if (itemIndex === -1) return itens;

    const novaOrdem = novaLista[itemIndex].order + (direcao === "up" ? -1 : 1);

    const itemTrocaIndex = novaLista.findIndex((item) => item.order === novaOrdem);

    if (itemTrocaIndex !== -1) {

      [novaLista[itemIndex].order, novaLista[itemTrocaIndex].order] = [novaLista[itemTrocaIndex].order, novaLista[itemIndex].order];

    }

    return novaLista.sort((a, b) => a.order - b.order);

  };

  deleteVar(itens, _var: ICalcVar) {

    let novaLista = itens.filter((item) => item.order !== _var.order);

    novaLista = novaLista.map((item, index) => ({ ...item, order: index + 1 }));

    return novaLista;

  }

  appendVar(itens, _var: ICalcVar) {

    return [...itens, _var];

  }

  validForDate(): ICalc[] {
    let date = moment(new Date()).format()
    return this.sorted.filter(calc => {
      if (calc.valido_de == null && calc.valido_ate == null) {
        return true;
      }

      if (date >= moment(calc.valido_de).format() && date <= moment(calc.valido_ate).format()) {
        return true;
      }

      if (calc.valido_de == null && date <= moment(calc.valido_ate).format()) {
        return true;
      }

      if (date >= moment(calc.valido_de).format() && calc.valido_ate == null) {
        return true;
      }

      return false;
    });
  }

  validForDateRetro(): ICalc[] {
    let date = moment(new Date()).format()

    return this.sorted.filter(calc => {
      if (calc.valido_de == null && date >= moment(calc.valido_ate).format()) {
        return true;
      }
      if (moment(calc.valido_de).format() <= date && date >= moment(calc.valido_ate).format()) {
        return true;
      }
      return false
    });
  }

  @computed
  get sorted(): ICalc[] {
    return sortBy(this.obs.calcs, "nome");
  }

  async handldeBuscaClassificacao() {
    try {
      this.obs.itens_classificacao = [];
      let params = {
        estado: "PA"
      }
      let resp = await api.post("/api/icms_classificacoes", params);

      this.obs.itens_classificacao = resp.data.itens
    } catch (ex) {
      toast.error("Erro ao carregar Icms Classficação!", {});
    }
  }

  async exportProdutos(calc_id: any) {
    try {
      let resp = await api_adm.post("/api/admin/calcs-produtos/export", { "id": calc_id, estado: "PA" });

      if (resp.data.ok) {
        const linkSource = `data:application/csv;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export_produtos.csv";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.warning('Não foram encontrados resultados.', {});
      }
    } catch (ex) {
      toast.error("Erro ao exportar Produtos, tente novamente mais tarde.", {});
    }
  }

  async handleCalcFiltered(tipo, text, vigencia) {

    try {

      let params = {
        tipo: tipo,
        vigencia: vigencia,
        filter: text
      }

      let resp = await api_adm.post("/api/admin/calcs/filtered", params);

      if (Array.isArray(resp.data)) {
        
        this.obs.calcs_index = resp.data.map((calc: ICalc) => ({
          ...calc,
          icms_classificacao: LookupStore.getIcmsClassificacao(calc.icms_classificacao_id)
        }));

      } else {

        this.obs.calcs_index = [];

      }

    } catch (ex) {

      toast.error('Erro filtrar Cálculos!.', {});

    }

  }

  async loadContas() {

    let resp = await api_adm.get("/api/admin/calc-contas")

    this.obs.contas = resp.data;

  }

  get filtered() {

    let filtered = this.obs.contas.filter(c => {
      return c.nome.toUpperCase().indexOf(this.obs.filter.toUpperCase()) != -1;
    });

    return sortBy(filtered, "inserted_at");
  }

  async handleImportProdutos(data) {

    try {

      let resp = await api_adm.post("/api/admin/calcs-produtos/import", data);

      if (!resp.data.length) {

        toast.success("Produtos importados com sucesso.", {});

      } else {

        toast.warn("Alguns produtos não foram importados.", {});

        return resp.data

      }

    } catch (e) {

      toast.error("Erro ao importar Produtos, tente novamente mais tarde.", {});

    }

    setInterval(() => { window.location.reload() }, 2000)

    return []
  }

  async handleCalcs() {

    try {

      let params = {
        tipo: "entrada",
        vigencia: "vigentes",
        filter: ""
      }

      let paramsContas = {
        tipo: "contas",
        vigencia: "vigentes",
        filter: ""
      }

      let respCalcs = await api_adm.post("/api/admin/calcs/filtered", params);
      let respContas = await api_adm.post("/api/admin/calcs/filtered", paramsContas);

      this.obs.calcs_class = [];

      this.obs.calcs_class = [...respCalcs.data, ...respContas.data]

    } catch (ex) {

      toast.error('Erro filtrar Cálculos!.', {});

    }

  }

  async createClassificacao(params) {

    try {

      let resp = await api_adm.post("/api/admin/icms_classificacoes/create", params);

      if (resp.data.ok) {

        toast.success('Classificação salva com sucesso!', {});
        return true

      } else {

        toast.error(`Não foi possível salvar Classificação: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Erro ao salvar Classificação!`, {});

    }

    return false

  }

  async updateClassificacao(params) {

    try {

      let resp = await api_adm.post("/api/admin/icms_classificacoes/update", params);

      if (resp.data.ok) {

        toast.success('Classificação salva com sucesso!', {});
        return true

      } else {

        toast.error(`Não foi possível salvar Classificação: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Erro ao salvar Classificação!`, {});

    }

    return false

  }

}

export const CalcStore = new _CalcStore();
